import React from 'react';
import './Logo.css';

import { images } from '../../constants';

import { Link } from "react-router-dom";

const Logo = ({ variant = 'main' }) => {

  // Select logo image based on variant
  const logoSrc = variant === 'footer' ? images.footerLogo : images.logo;

  return (
    // Link to the home page when the logo is clicked
    <Link to='/' className='logo'>

      {/* Logo Image */}
      <img src={logoSrc} alt='logo' />

      <div className='logo-content'>
        <h4><span>AS</span> Designs</h4>
      </div>

    </Link>
  );

}

export default Logo;